<template>
  <div class="google-calendar-modal">
    <HMModalHeader :title="title" @close="$emit('close')" />
    <div>
      <span>
        {{ description }}
      </span>
      <HMButton
        class="social-button w-100 mt-4"
        color="social"
        @click="connect"
      >
        <img
          class="mr-2 social-icon google"
          src="/assets/images/google_icon.png"
        />
        {{ $t('LOGIN.BUTTON.SIGN_IN_WITH_GOOGLE') }}
      </HMButton>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'ConnectGoogleModal',
  props: {
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    connectFunction: {
      type: Function,
    },
  },
  methods: {
    async connect() {
      await this.connectFunction();
      this.$emit('close');
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@500&display=swap');

.social-icon {
  width: 30px;
  height: 20px;
  &.google {
    height: 30px;
  }
}

.social-button {
  font-family: 'Roboto', sans-serif;
}
</style>
